module.exports = __webpack_public_path__ + "static/media/day14.workshop.a0da63ed.md";